import * as React from 'react';
import Multiselect from 'multiselect-react-dropdown';
import { useDispatch, useSelector } from 'react-redux';
import { dashboardActions } from '../../../_actions';
import { FaAngleDown } from "react-icons/fa";
import './multiselect.css'
export default function MultipleSelectChip({options,setoptions,handleMultiselectChange,selectedOptions}) {

  let dispatch = useDispatch()
  let selector = useSelector(state=>state)
 
  let data = {
    "keyWord": "",
    "pageNo": 1,
    "size": 10
  }
 
  React.useEffect(()=>{
    dispatch(dashboardActions.getTreatmentList(data))
  },[])




let {dashboard} = selector?selector:{}
let {TreatementList} = dashboard&&dashboard?dashboard:{}
let {physioTreatmentList}=dashboard&&dashboard.userData||{}
let {total , list} = TreatementList&&TreatementList?TreatementList:{}



 
  React.useEffect(() => {
    if (total>0&&list) {
      const newOptions = list.map((item) => ({ key: item.name, value: item.id }));
      setoptions(newOptions);
    }
  }, [total]);
  


  return (
    <div className=' bg-white relative flex flex-col justify-end'>
      <Multiselect
        options={options}
        displayValue="key"
        showCheckbox={true}
        selectedValues={selectedOptions}
        placeholder="Select Treatements"
        onSelect={handleMultiselectChange}
        onRemove={handleMultiselectChange}
        
      />
      <FaAngleDown className=' absolute right-1   top-2  ' />
      
    </div>
  );
}